export const TRANSLATIONS = {
  DELETE_PAYOUT_DRAFT_SUCCESS: (payoutDraftId: number) =>
    `Successfully deleted draft ${payoutDraftId}`,
  DELETE_PAYOUT_DRAFT_ERROR: 'Error while deleting the draft',
  DELETE_PAYOUT_DRAFT_TITLE: 'Delete draft?',
  DELETE_PAYOUT_DRAFT: 'Delete draft',
  DELETE_ARE_YOU_SURE: 'Are you sure you want to delete this payout draft?',
  REJECT_ARE_YOU_SURE: 'Are you sure you want to reject this payout draft?',
  SOMETHING_WENT_WRONG: 'Something went wrong',
  DETAILS: 'Details',
  YES: 'Yes',
  NO: 'No',
  APPROVE_PAYOUT_DRAFT_SUCCESS: (draftId: number) =>
    `Successfully approved draft with id: ${draftId}`,
  APPROVE_PAYOUT_DRAFT_ERROR: 'Error while approving the draft',
  REJECT_PAYOUT_DRAFT_SUCCESS: (draftId: number) =>
    `Successfully rejected draft with id: ${draftId}`,
  REJECT_PAYOUT_DRAFT_ERROR: 'Error while rejecting the draft'
};
